export const messages = {
    search: {
        button: 'Search tenders'
    },
    menu: {
        home: "Home",
        about: "About",
    },
    list: {
        tender: "Tender",
        buyer: "Buyer",
        supplier: "Supplier",
        source: "Source publication"
    }
}